import MyStoreModal from 'components/ShopYourStore/MyStoreModal/MyStoreModal';

export default MyStoreModal;
